module.exports = "body{\n    background-color: #3f546f;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-menu/no-menu.component.css
// module id = ./src/app/no-menu/no-menu.component.css
// module chunks = main